import { render, staticRenderFns } from "./ServicesList.vue?vue&type=template&id=232b5956&scoped=true"
import script from "./ServicesList.vue?vue&type=script&lang=js"
export * from "./ServicesList.vue?vue&type=script&lang=js"
import style0 from "./ServicesList.vue?vue&type=style&index=0&id=232b5956&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232b5956",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('232b5956')) {
      api.createRecord('232b5956', component.options)
    } else {
      api.reload('232b5956', component.options)
    }
    module.hot.accept("./ServicesList.vue?vue&type=template&id=232b5956&scoped=true", function () {
      api.rerender('232b5956', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ServicesList.vue"
export default component.exports